module.exports = require('./helpers/bundle-url').getBundleURL('h0ehp') + "icon-32x32.128c748e.png";